import React from 'react'
import { SiteHeader } from '../../components/site-header'
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card'
import { Button } from '../../components/ui/button'
import { Link } from 'react-router-dom'
import { CheckCircle2 } from 'lucide-react'

export default function ThankYouPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <div className="absolute inset-0 z-0 bg-background">
          <div className="relative w-full h-full">
            <img
              src="/images/backgrounds/flickr-21903280519.jpg"
              alt="Survey background"
              className="object-cover hero-bg w-full h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/70 to-background" />
          </div>
        </div>
        
        <div className="container relative z-10 py-24">
          <div className="max-w-xl mx-auto">
            <Card>
              <CardHeader className="text-center">
                <div className="flex justify-center mb-4">
                  <CheckCircle2 className="w-16 h-16 text-primary" />
                </div>
                <CardTitle className="text-2xl">Thank You for Completing the Survey</CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <p className="text-center text-muted-foreground">
                  Your responses have been recorded successfully. They will help provide valuable insights 
                  into your organisation's leadership tendencies and strategic alignment.
                </p>
                <div className="flex justify-center">
                  <Button asChild>
                    <Link to="/survey">Return to Survey Home</Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
    </div>
  )
}